<template>
  <div>
    <div
      v-loading="loading"
      class="templates"
    >
      <app-templates
        v-model="model.templates"
        @delete="removeTemplate"
        @edit="showEditTemplateDialog"
        @add="showAddTemplateDialog"
      />
    </div>

    <b-modal
      :title="$t('Edit object', { object: $tc('Templates', 1) })"
      :visible="editTemplateVisible"
      @hide="hideEditTemplateDialog"
    >
      <app-template-form
        v-model="editTemplateModel"
        :marketplace-id="model.marketplace.id"
      />
      <template slot="modal-footer">
        <button
          class="btn btn-primary"
          @click.prevent="saveTemplate"
        >
          {{ $t('Save') }}
        </button>
      </template>
    </b-modal>

    <b-modal
      :title="$t('Add object', { object: $tc('Templates', 1) })"
      :visible="addTemplateVisible"
      @hide="hideAddTemplateDialog"
    >
      <app-template-form
        v-model="addTemplateModel"
        :marketplace-id="model.marketplace.id"
        change-key
      />
      <template slot="modal-footer">
        <button
          class="btn btn-primary"
          @click.prevent="addTemplate"
        >
          {{ $t('Add') }}
        </button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import AppTemplates from '../components/templates/Templates.vue';
import AppTemplateForm from '../components/templates/TemplateForm.vue';
import MarketplacesCategoryMixins from '../mixins/MarketplacesCategoryMixins';

export default {
  name: 'AppPageMarketplacesCategoryTemplates',
  components: {
    AppTemplates,
    AppTemplateForm,
  },
  mixins: [
    MarketplacesCategoryMixins,
  ],
  data() {
    return {
      /**
         * Edit a template params
         */
      editTemplateModel: {},
      editTemplateVisible: false,
      /**
         * Add a template params
         */
      addTemplateModel: {},
      addTemplateVisible: false,
    };
  },
  watch: {
    '$route.params.categoryId': {
      immediate: true,
      handler(categoryId) {
        this.$marketplacesCategory_load(categoryId);
      },
    },
  },
  methods: {
    /**
       * Removes a template with specify key.
       * @param {string} key Template Key
       */
    removeTemplate(key) {
      // eslint-disable-next-line
      if (confirm(this.$t('Are you sure?'))) {
        const model = { ...this.model };
        model.templates = {};
        Object.keys(this.model.templates).forEach(e => {
          if (e !== key) {
            model.templates[e] = this.model.templates[e];
          }
        });
        this.model = model;
        this.$marketplacesCategory_save();
      }
    },
    /**
       * Opens a modal dialog with a form for editing a template.
       * @param {string} key Template Key
       */
    showEditTemplateDialog(key) {
      this.editTemplateModel = { key, ...this.model.templates[key] };
      this.editTemplateVisible = true;
    },
    /**
       * Closes a modal dialog with a form for editing a template.
       */
    hideEditTemplateDialog() {
      this.editTemplateModel = {};
      this.editTemplateVisible = false;
    },
    /**
       * Saving a template.
       * Actually only change a template information in a model.
       */
    saveTemplate() {
      const model = { ...this.model };
      const { key } = this.editTemplateModel;
      delete this.editTemplateModel.key;
      model.templates[key] = this.editTemplateModel;
      this.model = model;
      this.hideEditTemplateDialog();
      this.$marketplacesCategory_save();
    },
    /**
       * Opens a modal dialog with a form for editing a template.
       */
    showAddTemplateDialog() {
      this.addTemplateModel = {
        key: '',
        name: '',
        description: '',
        default: '',
        required: false,
      };
      this.addTemplateVisible = true;
    },
    /**
       * Closes a modal dialog with a form for editing a template.
       */
    hideAddTemplateDialog() {
      this.addTemplateModel = {};
      this.addTemplateVisible = false;
    },
    addTemplate() {
      if (this.addTemplateModel.key.length > 0 && this.addTemplateModel.name.length > 0) {
        const model = { ...this.model };
        model.templates[this.addTemplateModel.key] = {
          name: this.addTemplateModel.name,
          description: this.addTemplateModel.description,
          default: this.addTemplateModel.default,
          required: this.addTemplateModel.required,
        };
        this.model = model;
        this.$marketplacesCategory_save();
      }
      this.hideAddTemplateDialog();
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "~bootstrap-vars";

  .templates {
    height: calc(100vh - 260px);
    overflow-y: auto;
    overflow-x: hidden;
    padding-right: 20px;
  }
</style>
